// PWA: service worker бүртгэл + "Апп болгож суулгах" санал
let deferredPrompt = null;
const listeners = new Set();

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Браузер суулгах боломжтой гэж мэдэгдэхэд prompt-ыг хадгална
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

export const canInstall = () => !!deferredPrompt;

export function onInstallable(fn) {
  listeners.add(fn);
  fn(!!deferredPrompt);
  return () => listeners.delete(fn);
}

export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((fn) => fn(false));
  return outcome === "accepted";
}

// Аль хэдийн апп горимд (standalone) нээгдсэн эсэх
export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

// iOS Safari — beforeinstallprompt байхгүй тул зааварчилгаа харуулна
export const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
